import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Stack!=!/vercel/path0/node_modules/@mui/material/index.js");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Header/PointsNav.tsx")